import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Button, Dropdown, Image, Loader, Message, Popup } from "semantic-ui-react"
import InfoIcon from "../../../../images/info-Icon.svg"
import { MD_HD_VEHICLE_TYPE_ID } from "../../../../v1/constants/application"
import { numberFormatToCurrency } from "../../../../shared_component/utils/currency"
import { connect } from "react-redux"
import { shopPrice } from "../../Cart/CartServiceRow"
import { INSTACART, INSTACART_CANADA } from "../../../../v1/constants/affiliations"
import InstacartIcon from "../../../../images/instacart-icon.svg"
import { TIRE_SERVICES } from "../../../../v1/constants/tires"
import { textifiedPrice } from "../../../../v1/helpers/shopHelpers"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAdd } from "@fortawesome/pro-solid-svg-icons"
import { ReactComponent as CheckIcon } from "../../../../images/check-dynamic.svg"
import { ReactComponent as DeleteIcon } from "../../../../images/delete_icon_vector.svg"
import CircularLoader from "../../../../shared_component/components/CircularLoader"
import { OIL_CHANGE } from "../../../../v1/actions/services"
import Calender from "../../../../images/calendar-icon.svg"
import { appointmentTypes } from "../../../constants"
import { CA } from "../../../../v1/constants/states"

const ServiceCard = ({
  service,
  selectedServices,
  selectedPositions,
  serviceErrors,
  handleService,
  updateServiceWithPosition,
  activeVehicle,
  user,
  cart,
  isUpdating,
  recommendedServices,
  handleMarkServiceAsCompleted,
  promotion,
  hideActionButtons = false,
  hidePositions = false,
  hideAddedLabel = false
}) => {
  const { t } = useTranslation("common")
  const vehicleTypeId = activeVehicle && activeVehicle.vehicle_type_id
  const addedService = cart.order_services.find((item) => item.id == service.id)
  const [updating, setUpdating] = useState(false)
  const [showAdded, setShowAdded] = useState(false)

  const isOilChangeBenefitRedeemed = promotion?.length === 0

  const getPositions = (positions) => {
    if (service?.reference_id === OIL_CHANGE) {
      return positions
        ?.slice()
        ?.sort((a, b) => {
          if (a === activeVehicle?.oil_type_name) return -1
          if (b === activeVehicle?.oil_type_name) return 1
          return 0
        })
        .map((position, index) => ({
          key: index,
          text:
            position +
            (position === activeVehicle?.oil_type_name ? " (Manufacturer" + " recommended)" : ""),
          value: position
        }))
    }

    return positions.map((position, index) => ({
      key: index,
      text: position,
      value: position
    }))
  }
  const isInstacartUser = [INSTACART, INSTACART_CANADA].includes(
    user?.affiliation?.root_reference_id
  )

  const formattedPrice = (price, t, user, shop, os, isTireOrder) => {
    const isTireService = TIRE_SERVICES.includes(os.name)
    let activeVehicle
    if (user)
      activeVehicle =
        user.vehicles && user.vehicles.filter((item) => item.id == user.activeVehicleId)
    if (!user?.activeVehicleId) {
      return t("common:addTheVehicleLabel")
    } else if (isTireOrder) {
      return t("orderServicePriceRow:includeTirePriceLabel")
    } else if (shop && shop.cdk_dealer) {
      return t("orderServicePriceRow:seeDealerPriceLbl")
    } else if (Math.sign(price) == 1) {
      return textifiedPrice({ price: price, t: t, prepaid: os.prepaid })
    } else {
      if (shop && shop.is_cdk_dealer) {
        return t("orderServicePriceRow:seeDealerPriceLbl")
      } else if (
        activeVehicle &&
        activeVehicle.length > 0 &&
        activeVehicle[0].vehicle_type_id === MD_HD_VEHICLE_TYPE_ID
      ) {
        return t("orderServicePriceRow:pricedAtShop")
      } else if (isTireService && (price === undefined || price === 0)) {
        return t("orderServicePriceRow:Free")
      } else return t("orderServicePriceRow:pricedAtShop")
    }
  }

  useEffect(() => {
    if (isUpdating) {
      setUpdating(true)
    } else {
      updating && serviceAdded()
    }
  }, [isUpdating])

  const serviceAdded = () => {
    setShowAdded(true)
    setTimeout(() => {
      setShowAdded(false)
      setUpdating(false)
    }, 1000)
  }

  return (
    <div className="service-list-card">
      <div className="service-list-tile">
        <div className="service-info">
          <label key={service.name}>
            {service.display_name || service.name || service.service_name}
            {service?.one_liner?.length > 0 && (
              <Popup
                content={service.one_liner || service.name}
                trigger={<Image src={InfoIcon} />}
                inverted
                position="bottom center"
                on="click"
              />
            )}
            {isInstacartUser && service.name == "Oil Change" && !isOilChangeBenefitRedeemed && (
              <span className="benefit-label">
                <Image src={InstacartIcon} />
                {t("benefit")}
              </span>
            )}
          </label>
          <div className="service-price-info">
            {user.country === CA ? (
              <p className="price-text">{t("mdHdpricedAtShopLbl")}</p>
            ) : selectedServices.includes(service.id) && addedService && cart?.shop?.id ? (
              formattedPrice(
                shopPrice(addedService.price_estimate, addedService),
                t,
                user,
                cart?.shop || {},
                addedService,
                null
              )
            ) : !service.price_estimate || !service.high_price_estimate ? (
              vehicleTypeId && vehicleTypeId === MD_HD_VEHICLE_TYPE_ID ? (
                <p className="price-text">{t("mdHdpricedAtShopLbl")}</p>
              ) : service.high_price_estimate &&
                service.low_price_estimate &&
                service.high_price_estimate.shop_price_estimate !=
                  service.low_price_estimate.shop_price_estimate ? (
                <p className="price-text">
                  {" "}
                  {`${numberFormatToCurrency(
                    service.low_price_estimate.shop_price_estimate
                  )} - ${numberFormatToCurrency(service.high_price_estimate.shop_price_estimate)}`}
                </p>
              ) : service.high_price_estimate ? (
                `${numberFormatToCurrency(service.high_price_estimate.shop_price_estimate)}`
              ) : service.price_range_from && service.price_range_to ? (
                <p className="price-text">
                  {" "}
                  {`${numberFormatToCurrency(service.price_range_from)} - ${numberFormatToCurrency(
                    service.price_range_to
                  )}`}
                </p>
              ) : !user?.activeVehicleId ? (
                <p className="price-text">{t("addTheVehicleLabel")}</p>
              ) : (
                <p className="price-text">
                  {service.reference_id === "buy_new_tires"
                    ? ""
                    : t("orderServicePriceRow:pricedAtShop")}
                </p>
              )
            ) : null}
          </div>
          {addedService && !hideAddedLabel && (
            <div className="service-added">
              <CheckIcon />
              Added
            </div>
          )}
          {service.is_completed && (
            <div className="service-added">
              <CheckIcon />
              Service marked as completed
            </div>
          )}
          {recommendedServices && !service.is_completed && (
            <div
              className="mark-service-completed"
              onClick={() => handleMarkServiceAsCompleted(service)}
            >
              Mark service as completed
            </div>
          )}
        </div>
        {isUpdating && <CircularLoader />}
        {!hideActionButtons &&
          !isUpdating &&
          (addedService ? (
            showAdded ? (
              <Button className="primary-button service-added flex gap-10" disabled>
                <CheckIcon />
                Added
              </Button>
            ) : (
              <div className="remove-service" onClick={() => handleService(service, null)}>
                <DeleteIcon />
                Remove
              </div>
            )
          ) : (
            <Button
              className="primary-button flex gap-10"
              onClick={() => handleService(service, null)}
            >
              {service.reference_id !== "buy_new_tires" && <FontAwesomeIcon icon={faAdd} />}
              {service.reference_id === "buy_new_tires" ? "Shop Now" : "Add"}
            </Button>
          ))}
      </div>

      {!hideActionButtons &&
        !hidePositions &&
        (service.positions?.length || service?.service_options?.[0]?.positions?.length || 0) != 0 &&
        !addedService && (
          <>
            <Dropdown
              className="select-category"
              placeholder={t("addService:selectOne")}
              fluid
              name={service.id}
              selection
              options={getPositions(service.positions || service?.service_options?.[0]?.positions)}
              value={selectedPositions[service.id] || null}
              error={serviceErrors[service.id]}
              onChange={(e, data) => {
                updateServiceWithPosition(service, data.value)
              }}
            />
            {serviceErrors[service.id] && (
              <Message size="mini" negative>
                {serviceErrors[service.id]}
              </Message>
            )}
          </>
        )}
    </div>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  const promotion =
    state.promotionData.customerPromotions?.filter(
      (promotion) => promotion.service_definition_name === OIL_CHANGE
    ) || []
  let cart
  let isCart
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  let currentActiveOrder =
    user.active_orders && user.active_orders.find((o) => o.vehicle_id == user.activeVehicleId)
  if (currentActiveOrder) {
    cart = currentActiveOrder
    isCart = false
  } else {
    isCart = true

    if (props.cartId) {
      cart = user.active_carts && user.active_carts.filter((c) => c.id == Number(props.cartId))[0]
    } else {
      cart =
        user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
    }
  }

  if (!cart || !cart.order_services) {
    cart = { estimated_total: 0, order_services: [] }
  }

  return {
    user: user,
    activeVehicle,
    cart: cart,
    promotion
  }
}

export default connect(mapStateToProps)(ServiceCard)
